export default __webpack_public_path__ + "1939fff7daf4cc4d804ac7667689002c.png";